/**
 * Encadré « L'essentiel » placé en haut des grandes pages thématiques :
 * 3 à 5 phrases autoportantes, faciles à reprendre par Google et les
 * assistants IA. Rendu côté serveur (texte présent dans le HTML).
 */
export function KeySummary({ points, title = "L'essentiel" }: { points: string[]; title?: string }) {
  if (!points.length) return null;
  return (
    <aside
      aria-label={title}
      className="mt-8 max-w-3xl border-l-2 border-primary bg-muted/40 px-5 py-4"
    >
      <h2 className="text-[0.7rem] font-semibold uppercase tracking-[0.25em] text-primary">
        {title}
      </h2>
      <ul className="mt-3 space-y-2 text-sm leading-relaxed text-foreground">
        {points.map((p) => (
          <li key={p} className="flex gap-2">
            <span aria-hidden className="text-primary">—</span>
            <span>{p}</span>
          </li>
        ))}
      </ul>
    </aside>
  );
}
